// "/users/:id" + { id: 42 } → "/users/42", the inverse of preact-iso's `exec`.
// Optional/rest params left empty drop their segment. A trailing slash in the
// pattern is kept — "/page/:name/" → "/page/LAN/", the url of a prerendered
// page/LAN/index.html.
import { NullQ } from "@pdfking/structs"
export const FillPath = (pattern: string, data: Record<string, unknown>): string => {
  const path = `/${pattern
    .split("/")
    .filter(Boolean)
    .map(segment => {
      const [, param, name] = /^(:?)(.*?)[+*?]?$/.exec(segment) ?? []
      if (!param) return segment
      const value = data[name ?? ""]
      return NullQ(value) || value === "" ? "" : encodeURIComponent(String(value))
    })
    .filter(Boolean)
    .join("/")}`
  return pattern.endsWith("/") && path !== "/" ? `${path}/` : path
}
